<template>
  <div class="navMenu">
    <nav class="navMenu-navbar" ref="navbar">
      <ul>
        <li class="navMenu-navbar-item" v-for="(nav, index) in this.pageSet" :key="index" @click="handleNavMenuVisible">
          <router-link :to="{ name: 'top', hash: nav.path }" v-smooth-scroll>
            <span>{{ nav.alt }}</span>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'NavMenu',
  props: {
    pageSet: {
      required: true
    }
  },
  methods: {
    handleNavMenuVisible () {
      this.$emit('closeNavMenu')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import url('https://use.typekit.net/ezx8vjy.css');

.navMenu {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 90px 40px 0;
  background-color: rgba($color: #000000, $alpha: 0.85);
  z-index: 50;
  &-navbar {
    &-item {
    text-align: left;
    color: white;
    letter-spacing: 0.05em;
    font: normal normal bold 35px hypatia-sans-pro;
      &:not(:first-of-type) {
        margin-top: 25px;
      }
    }
    &-img {
      zoom: 1.8;
    }
  }
}
</style>
